import { render, staticRenderFns } from "./ZoomImage.vue?vue&type=template&id=45fd0aaa&"
import script from "./ZoomImage.vue?vue&type=script&lang=js&"
export * from "./ZoomImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports